import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a3a7a2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "after-Sales" }
const _hoisted_2 = {
  key: 0,
  class: "after-sale-tip flex-ter"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-tishi1" }, null, -1))
const _hoisted_4 = { class: "after-sale-tip-text" }
const _hoisted_5 = { style: {"font-size":"13px"} }
const _hoisted_6 = { class: "upload-img-tip" }
const _hoisted_7 = { class: "footer flex-ter-end" }

import { t } from '@/plugins/i18n'
import { ref, toRaw, watch, computed } from 'vue'
import { cloneDeep } from 'lodash'
import { setDefaultForm } from '@/util/common'
import UploadImage from './UploadImage.vue'
import ShoppingPreview from './ShoppingPreview.vue'
import useFileUtils from '@/util/useFileUtils'

import { showCurrentUnit } from '@/util/useYan'
import { afterSalesHandling } from '@/apis/order'
import { ElMessage } from 'element-plus'
import { COUNTRY } from '@/global'


export default /*#__PURE__*/_defineComponent({
  props: {
  rowItem: {
    type: Object,
    default: () => ({})
  },
  isChoice: {
    type: Boolean,
    default: false
  }
},
  emits: ['cancel', 'success'],
  setup(__props, { emit: emits }) {

const props = __props

const limitFile = {
  accept: '.jpg,.jpeg,.png,.JPG,.JPEG,.PNG',
  beforeUpload: (file: any) => {
    const { getExtension } = useFileUtils()
    const ext = getExtension(file.name)
    const limitList = ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG']
    console.log(ext)
    if (!limitList.includes(ext)) {
      ElMessage.warning(t('上传文件只能是X格式').replace('X', [...new Set(limitList.map(v => v.toUpperCase()))].join('/')))
      return false
    }
    const size = file.size / 1024 / 1024
    if (size > 10) {
      ElMessage.warning(t('文件大小不超过10M'))
      return false
    }
    return true
  }
}


const defaultForm = {
  afterSalesReason: '',
  applyAfterSalesQuantity: '',
  afterSalesProgress: '', //  申请售后 1  重新发起 4
  detailedExplain: '',
  afterSalesImg: '',
  abnormalOrderId: '',
  shopProductSkus: []
}

const setAfterSalesProgressDict: any = {
  0: 1, // 待处理 0 到 申请售后 1
  4: 5 // 重新发起 4 到 重新发起（处理中）5
}

const formRules: any = {
  afterSalesReason: [
    { required: true, message: t('必填'), trigger: 'change' }
  ],
  applyAfterSalesQuantity: [
    { required: true, message: t('必填'), trigger: 'blur' }
  ],
  afterSalesImg: [
    { required: true, message: t('必填'), trigger: 'change' }
  ]
}

const afterSalesReasonDict: any = {
  1: t('次品2'),
  2: t('相异品'),
  3: t('数量不足'),
  4: t('其他')
}

const afterSalesRefundTotalAmount = computed(() => {
  return props.isChoice ? (props.rowItem.allIncludePriceResultDetail?.allIncludeProductPrice * _form.value.applyAfterSalesQuantity) : props.rowItem.actualProductSellPrice * _form.value.applyAfterSalesQuantity
})

const getForm = (form: any) => {
  const newForm = setDefaultForm(cloneDeep(toRaw(form)), defaultForm)
  const afterSalesImg = newForm.afterSalesImg ? newForm.afterSalesImg.split(',') : []
  return {
    afterSalesReason: newForm.afterSalesReason,
    applyAfterSalesQuantity: newForm.applyAfterSalesQuantity || props.rowItem.orderQuantity,
    afterSalesProgress: setAfterSalesProgressDict[newForm.afterSalesProgress], //  申请售后 1  重新发起 4
    detailedExplain: newForm.detailedExplain,
    afterSalesImg,
    abnormalOrderId: newForm.abnormalOrderId,
    shopProductSkus: [newForm.shopProductSku]
  }
}

const _form = ref(getForm(props.rowItem))

watch(() => props.rowItem, (newValue) => {
  _form.value = getForm(newValue)
}, { deep: true })

const inputPrice: any = () => {
  const num = _form.value.applyAfterSalesQuantity.toString().match(/^\d*(\.?\d{0,})/g)[0]
  _form.value.applyAfterSalesQuantity = num
}

const changePrice: any = () => {
  const num = _form.value.applyAfterSalesQuantity.toString().match(/^\d*(\.?\d{0,})/g)[0]
  _form.value.applyAfterSalesQuantity = num > 0 ? Math.min(num, (props.rowItem.orderQuantity || 1)) : 1
}

const formRef = ref()
const submitLoading = ref(false)
const submit = () => {
  if (!formRef.value) return
  formRef.value.validate((valid: any) => {
    if (valid) {
      const { afterSalesImg } = toRaw(_form.value)
      submitLoading.value = true
      afterSalesHandling({
        ...toRaw(_form.value),
        platformOrderNo: props.rowItem.platformOrderNo,
        afterSalesRefundTotalAmount: afterSalesRefundTotalAmount.value,
        afterSalesImg: afterSalesImg.join(','),
        systemOrderNo: [props.rowItem.systemOrderNo]
      }).then((res: any) => {
        if (res.success) {
          ElMessage.success(t('申请成功2'))
          submitLoading.value = false
          emits('success')
        } else {
          submitLoading.value = false
        }
      }).catch(() => {
        submitLoading.value = false
      })
    } else {
      return false
    }
  })
}
const changeImage = () => {
  formRef.value.validateField(['afterSalesImg'])
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ShoppingPreview, {
        image: __props.rowItem.productSkuImg || __props.rowItem.productMainImg || '',
        name: __props.rowItem.productTitleJp || '',
        url: __props.rowItem.productDetailUrl || undefined
      }, null, 8, ["image", "name", "url"]),
      (__props.rowItem.spotCheckQuantity && __props.rowItem.spotCheckQuantity > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('使用了抽检服务，无法发起次品售后')), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form, {
        ref: (_value, _refs) => {
          _refs['formRef'] = _value
          formRef.value = _value
        },
        model: _form.value,
        rules: formRules,
        "label-width": "120px",
        class: "form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _unref(t)('售后原因'),
            prop: "afterSalesReason"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _form.value.afterSalesReason,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_form.value.afterSalesReason) = $event)),
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(afterSalesReasonDict, (k, v) => {
                    return _createVNode(_component_el_option, {
                      key: Number(v),
                      label: k,
                      value: Number(v),
                      disabled: __props.rowItem.spotCheckQuantity && __props.rowItem.spotCheckQuantity > 0 && Number(v) === 1
                    }, null, 8, ["label", "value", "disabled"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('详细说明')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _form.value.detailedExplain,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_form.value.detailedExplain) = $event)),
                type: "textarea",
                maxlength: 250
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('申请售后数量'),
            prop: "applyAfterSalesQuantity"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _form.value.applyAfterSalesQuantity,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_form.value.applyAfterSalesQuantity) = $event)),
                style: {"width":"100%"},
                onInput: inputPrice,
                onChange: changePrice
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('售后退款金额')
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(afterSalesRefundTotalAmount)&&_unref(afterSalesRefundTotalAmount).toFixed(__props.rowItem.goodsCountry === _unref(COUNTRY).KR ? 0 : 2)) + _toDisplayString(_unref(showCurrentUnit)(__props.rowItem.goodsCountry === _unref(COUNTRY).KR)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            prop: "afterSalesImg",
            label: _unref(t)('图片')
          }, {
            default: _withCtx(() => [
              _createVNode(UploadImage, {
                urlList: _form.value.afterSalesImg,
                "onUpdate:urlList": _cache[3] || (_cache[3] = ($event: any) => ((_form.value.afterSalesImg) = $event)),
                limitFile: limitFile,
                onChange: changeImage
              }, null, 8, ["urlList"]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('点击上传图片（最多上传5张）(只能上传jpg/png文件，且不超过10M)')), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_button, {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (emits('cancel'))),
        class: "btn"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        loading: submitLoading.value,
        onClick: submit,
        disabled: __props.rowItem.spotCheckQuantity && __props.rowItem.spotCheckQuantity > 0 && _form.value.afterSalesReason === 1,
        class: "btn"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('确定')), 1)
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ])
  ], 64))
}
}

})